import React, { Component } from 'react'
import {
  saveSideBarState,
  retrieveSideBarState,
} from '../../utils/localStorage'
import './SideBar.css'
import { withRouter } from 'react-router-dom'
import { Link } from 'react-router-dom'
import Sqaure from '../Square/Square'
import { logger } from '../../utils/logger'
import { IoHourglassOutline } from 'react-icons/io5'
import {
  BsClipboardCheck,
  BsTabletFill,
  BsTabletLandscape,
} from 'react-icons/bs'
import { RiMessage2Fill, RiSurveyFill } from 'react-icons/ri'

import { MdEventSeat, MdUpdate } from 'react-icons/md'
import {
  Nav,
  NavItem,
  Collapse,
  Popover,
  PopoverHeader,
  PopoverBody,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Progress,
  Card,
} from 'reactstrap'
import {
  planningValues,
  dynamic_urls,
  dashboardMenuValues,
  groupMenuValues,
  renderGenderPronoun,
  profilePicValidityCheck,
  TRIVIA_DESCRIPTION,
  getTrivvyPlanName,
  checkValidationOfModule,
} from '../../utils/constants'
import { staticTitles, storyValues, isTrivvyUrl } from '../../utils/constants'
import axios from '../../axios'
import * as url from '../../utils/url'
import Tooltip from '../UI/TooltipIcon/TooptipIcon'
import tooltipIcon from '../../assets/tooltip.png'
import trivvyLogo from '../../assets/trivvy/trivvy-logo-img.png'
import trivvyTxt from '../../assets/trivvy/trivvy-logo-txt.png'
import { BiMemoryCard, BiNotepad, BiParagraph, BiUser } from 'react-icons/bi'
import UploadUsersModal from '../../pages/trivia/Components/UploadUsersModal'
import ReactTooltip from 'react-tooltip'
import ResponsePurchaseModal from '../../pages/trivia/Components/ResponsePurchaseModal'
import { BsGearFill } from 'react-icons/bs'
import InviteAdminsTrivvy from '../../pages/office/InviteOfficeMates/InviteAdminsTrivvy'
import UpgradePlanModal from '../../pages/trivia/Components/UpgradePlanModal'
import { isMobile } from '../../utils/deviceInfo'
import TriviaTemplatesModalMain from '../../pages/trivia/Components/CreateTrivia/TrivvyTemplatesModalMain'
import { minPlanLimitCheck } from '../../pages/trivia/data'
import { FaTasks } from 'react-icons/fa'
import { toolkitCategories } from '../../utils/categories'
import TrivvyEnterpriseConfigsModal from '../../pages/trivia/Components/CreateTrivia/TrivvyEnterpriseConfigsModal'
import { FaBuilding } from 'react-icons/fa6'

const d = 0,
  s = 1,
  p = 2,
  a = 3,
  t = 4,
  g = 5,
  m = 6,
  events = 7,
  r = 8,
  trv = 11,
  // dc=10,
  dc = 9,
  dmm = 10,
  upgradeTxt = 'upgrade'

// import { storyValues } from "../../utils/constants";

class SideBar extends Component {
  constructor(props) {
    super(props)
    this.state = {
      accordion: null,
      accordinonTabs: null,
      activityCategories: planningValues,
      groupCategories: groupMenuValues,
      dashboardCategories: dashboardMenuValues,
      storyCategories: storyValues,
      path: this.props.location.pathname.split('/'),
      custom_sidebar: null,
      openSideBar: '',
      currentModule: this.props.location.pathname,
      genderPronounInstOpen: false,
      uploadUsersModal: false,
      purchaseResponsesModal: false,
      inviteAdminModal: false,
      upgradePlanModal: false,
      trivvyTemplateModalOpen: false,
      missionValuesIndustryModal: false,
    }
  }

  checkPlanningUrl = (pathname) => {
    let planningUrlArr = planningValues.reduce(function(accumulator, curValue) {
      // return accumulator.concat(curValue.selected)

      return accumulator.concat(curValue.selected)
    }, [])

    if (
      pathname.startsWith('/home/my-activity') ||
      pathname.startsWith('/home/shared-activity') ||
      pathname.startsWith('/home/public-activity') ||
      pathname.startsWith('/home/planning') ||
      pathname.startsWith('/home/archived-activity') ||
      pathname.startsWith('/home/enterprise-objective') ||
      pathname.startsWith('/home/enterprise-associatedActions') ||
      planningUrlArr.indexOf(pathname) > -1
    ) {
      return true
    }
    return false
  }

  toggleAccordion(tab) {
    let { accordion } = this.state

    this.setState({
      accordion: accordion == tab ? null : tab,
    })
    // saveSideBarState(state);
  }

  checkEventUrl = (url) => {
    let { user } = this.props

    let eventUrl = dynamic_urls(user, user.organizationId).my_events

    if (url == eventUrl) {
      return true
    }

    return false
  }

  checkProfileUrl = (url) => {
    let { user } = this.props
    let profileUrl = dynamic_urls(user, user.organizationId).my_profile

    if (url == profileUrl) {
      return true
    } else if (url == profileUrl) {
      return true
    }

    return false
  }

  checkForGroupStories = () => {
    let { user, location } = this.props
    if (user.groupStory && user.groupStory.groupId) {
      return location.pathname.indexOf(user.groupStory.storyId) > -1
    }
  }

  componentWillReceiveProps(nextProps) {
    // change this if you change order of NavBar

    // console.log('nextProps----', nextProps)

    if (this.state.path !== nextProps.location.pathname.split('/')) {
      this.setState({ path: nextProps.location.pathname.split('/') })
    }

    // profileURL = dynamic_urls(this.props.user, this.props.user.organizationId).profile
    // myEventsURL = dynamic_urls(this.props.user, this.props.user.organizationId).my_events

    let { pathname } = nextProps.location
    // console.log('pathname--- ', pathname)
    if (pathname.indexOf('toolkit') > -1) {
      this.setState({ accordion: t })
    } else if (pathname.indexOf('analytics') > -1) {
      this.setState({ accordion: a })
    } else if (
      pathname.indexOf('stories') > -1 &&
      this.checkForGroupStories() != true
    ) {
      this.setState({ accordion: s })
    } else if (
      pathname.indexOf('dashboard') > -1 ||
      pathname.indexOf('dashboard-list') > -1
    ) {
      this.setState({ accordion: d })
    } else if (pathname.indexOf('group') > -1 || this.checkForGroupStories()) {
      this.setState({ accordion: g })
    } else if (this.checkPlanningUrl(pathname)) {
      this.setState({ accordion: p })
    } else if (this.checkProfileUrl(pathname)) {
      this.setState({ accordion: m })
    } else if (this.checkEventUrl(pathname)) {
      this.setState({ accordion: events })
    } else if (pathname.indexOf('/trivia') > -1) {
      // this.setState({ accordion: trv });
    } else if (
      pathname.indexOf(`groups/${this.props.user.organizationId._id}/create`) >
      -1
    ) {
      this.setState({ custom_sidebar: g })
    } else if (pathname.indexOf('/reporting/') > -1) {
      this.setState({ accordion: r })
    } else if (pathname.indexOf('/diversity-calendar') > -1) {
      this.setState({ accordion: dc })
    } else if (pathname.indexOf('/dei-maturity-model') > -1) {
      this.setState({ accordion: dmm })
    } else {
      this.setState({ accordion: null })
    }

    let { path, accordion, accordinonTabs } = this.state
    let { organizationId } = this.props.user
    let {
      isCultureApp,
      isToolkit,
      isAnalytics,
      isPlanning,
      selectModule,
    } = organizationId
    // if(selectModule && accordion==null && accordinonTabs==null){
    //   if(isAnalytics.status){
    //     this.setState({accordion: d})
    //   } else if(isCultureApp.status){
    //     this.setState({accordion: s})
    //   } else if(isPlanning.status){
    //     this.setState({accordion: p})
    //   } else if(isToolkit.status){
    //     this.setState({accordion: t})
    //   }
    // }
  }

  componentDidMount() {
    // console.log(this.props,'---this---', this.props.location.pathname.split('/'))
    // if (retrieveSideBarState() !== null) {
    //   let retrivedSideBarState = retrieveSideBarState().split(",");
    //   retrivedSideBarState = retrivedSideBarState.map(state => {
    //     if (state === "true") return true;
    //     else return false;
    //   });
    //   this.setState({ accordion: retrivedSideBarState });
    // }
    let pathname = this.props.location.pathname
    // console.log('pathname: ', pathname)

    if (pathname.indexOf('toolkit') > -1) {
      this.setState({ accordion: t })
    } else if (pathname.indexOf('analytics') > -1) {
      this.setState({ accordion: a })
    } else if (
      pathname.indexOf('stories') > -1 &&
      this.checkForGroupStories() != true
    ) {
      this.setState({ accordion: s })
    } else if (
      pathname.indexOf('dashboard') > -1 ||
      pathname.indexOf('dashboard-list') > -1
    ) {
      this.setState({ accordion: d })
    } else if (pathname.indexOf('group') > -1 || this.checkForGroupStories()) {
      this.setState({ accordion: g })
    } else if (this.checkPlanningUrl(pathname)) {
      this.setState({ accordion: p })
    } else if (this.checkProfileUrl(pathname)) {
      this.setState({ accordion: m })
    } else if (this.checkEventUrl(pathname)) {
      this.setState({ accordion: events })
    } else if (pathname.indexOf('/reporting/') > -1) {
      this.setState({ accordion: r })
    } else if (pathname.indexOf('/trivia') > -1) {
      this.setState({ accordion: trv })
    }

    if (
      pathname.indexOf(`groups/${this.props.user.organizationId._id}/create`) >
      -1
    ) {
      this.setState({ custom_sidebar: g })
    }

    let { path, accordion, accordinonTabs } = this.state
    let { organizationId } = this.props.user
    let {
      isCultureApp,
      isToolkit,
      isAnalytics,
      isPlanning,
      selectModule,
    } = organizationId
    // if(selectModule && accordion==null && accordinonTabs==null){
    //   if(isAnalytics.status){
    //     this.setState({accordion: d})
    //   } else if(isCultureApp.status){
    //     this.setState({accordion: s})
    //   } else if(isPlanning.status){
    //     this.setState({accordion: p})
    //   } else if(isToolkit.status){
    //     this.setState({accordion: t})
    //   }
    // }
  }

  isWeeklyWinsUrl = () => {
    return this.props.location.pathname.indexOf('my-activity') > -1
  }
  isToolkitUrl = () => {
    return this.props.location.pathname.indexOf('toolkit') > -1
  }
  isAnalyticsUrl = () => {
    return this.props.match.url.indexOf('analytics') > -1
  }
  isReportingUrl = () => {
    return this.props.match.url.indexOf('reporting') > -1
  }

  validateEnableModule = (setupSkipped, isModule, type) => {
    const { selectModule } = this.props.user.organizationId
    let enabled = false
    if (selectModule) {
      if (isModule && isModule.status) {
        if (
          isModule &&
          (isModule.isDisplayed || !isModule.hasOwnProperty('isDisplayed'))
        ) {
          enabled = true
        } else {
          enabled = false
        }
      }
    } else {
      if (
        isModule &&
        (isModule.isDisplayed || !isModule.hasOwnProperty('isDisplayed'))
      ) {
        enabled = true
      } else {
        enabled = false
      }
    }

    if (type === 'Planning') {
      return this.renderPlanning(enabled)
    } else if (type === 'CultureApp') {
      return this.renderCultureApp(enabled)
    } else if (type === 'Groups') {
      return this.renderGroups(enabled)
    } else if (type === 'Analytics') {
      return this.renderAnalytics(enabled)
    } else if (type === 'Toolkit') {
      return this.renderToolKit(enabled)
    } else if (type === 'DiversityCalendar') {
      return this.renderDiversityCalendar(enabled)
    } else if (type === 'DEIMaturityModel') {
      return this.renderDEIMaturityModel(enabled)
    }
  }

  goDashboard = () => {
    let url =
      this.props.match.url +
      '/dashboard-list/' +
      this.props.user.organizationId._id
    this.props.history.push(url)
  }
  goTrivia = () => {
    const { accordion } = this.state
    this.setState({
      accordion: accordion == trv ? null : trv,
    })
    let url =
      this.props.match.url +
      '/trivia/' +
      this.props.user.organizationId._id +
      '/' +
      'list'
    this.props.history.push(url)

    // this.props.history.push("list");

    // this.props.history.push("library");
    // this.props.history.push("list");
  }

  goAnnualObservances = () => {
    let url = this.props.match.url + '/diversity-calendar'
    this.props.history.push(url)
  }
  goDEIMaturityModel = () => {
    let url = this.props.match.url + '/dei-maturity-model'
    this.props.history.push(url)
  }

  renderDashboard = () => {
    let { isSetupSkipped } = this.props.user.organizationId

    let { path, accordion, accordinonTabs } = this.state
    let { organizationId } = this.props.user
    let { isAnalytics, isCultureApp, selectModule } = organizationId
    if (
      isAnalytics &&
      isAnalytics.status &&
      selectModule &&
      isCultureApp.status != true &&
      accordion == null &&
      accordinonTabs == null
    ) {
      this.setState({ accordion: d })
    }

    let isEnabled =
      (isAnalytics && isAnalytics.status && selectModule) ||
      !selectModule ||
      selectModule == undefined ||
      selectModule == null
        ? true
        : false

    console.log(
      [
        !isSetupSkipped,
        isAnalytics && isAnalytics.status && selectModule,
        !selectModule || selectModule == undefined || selectModule == null,
      ],
      isSetupSkipped
    )

    if (
      !isSetupSkipped &&
      ((isAnalytics && isAnalytics.status && selectModule) ||
        !selectModule ||
        selectModule == undefined ||
        selectModule == null)
    ) {
      console.log('first')
      return (
        <div>
          <div
            // onClick={() => this.toggleAccordion(d)}
            className="sidebar-category-section"
            onClick={() => this.goDashboard()}>
            <div
              className={
                this.state.accordion === d
                  ? 'sidebar-menuItem active'
                  : 'sidebar-menuItem'
              }
              style={{
                fontWeight: this.state.accordion == d ? '600' : 'normal',
              }}>
              Dashboard
            </div>
          </div>
        </div>
      )
    } else {
      return (
        <div>
          <div
            className="sidebar-category-section nic_opt_sdm"
            style={{ cursor: 'default' }}>
            <div
              className={'sidebar-menuItem'}
              style={{ fontWeight: 'normal', color: '#5152534a' }}>
              Dashboard ({upgradeTxt})
            </div>
          </div>
        </div>
      )
    }
  }

  renderTrivia = () => {
    // let { isSetupSkipped } = this.props.user.organizationId;

    let { path, accordion, accordinonTabs } = this.state
    let { organizationId } = this.props.user
    // let { isAnalytics, isCultureApp, selectModule } = organizationId;

    // let isEnabled =
    //   (isAnalytics && isAnalytics.status && selectModule) ||
    //   !selectModule ||
    //   selectModule == undefined ||
    //   selectModule == null
    //     ? true
    //     : false;

    return (
      <div>
        {/* {isTrivvyUrl(organizationId) ? (
          <div className="ml-3 mt-3">{this.renderTrivvySettings()}</div>
        ) : (
          <div
            // onClick={() => this.toggleAccordion(d)}
            className="sidebar-category-section cursor-pointer"
            onClick={() => this.goTrivia()}>
            <div
              className={
                this.state.accordion === trv
                  ? 'sidebar-menuItem active'
                  : 'sidebar-menuItem'
              }
              style={{
                fontWeight: this.state.accordion == trv ? '600' : 'normal',
              }}>
              Trivvy
            </div>
          </div>
        )} */}

        {!isTrivvyUrl(organizationId) && (
          <Collapse
            isOpen={this.state.accordion == trv}
            style={{ paddingBottom: '0px', marginTop: '-10px' }}>
            <Nav vertical className="category-wrapper">
              <NavItem className="nav-item text-md mt10">
                {this.renderTrivvySettings()}
              </NavItem>
            </Nav>
          </Collapse>
        )}
      </div>
    )
  }

  renderDiversityCalendar = (isEnabled) => {
    let { isSetupSkipped } = this.props.user.organizationId

    let { path, accordion, accordinonTabs } = this.state
    let { organizationId } = this.props.user
    let { isDiversityCalendar, selectModule } = organizationId
    // if (
    //   accordion == null &&
    //   accordinonTabs == null
    // ) {
    //   this.setState({ accordion: dc });
    // }

    if (isEnabled) {
      console.log('first')
      return (
        <div>
          <div
            // onClick={() => this.toggleAccordion(d)}
            className="sidebar-category-section"
            onClick={() => this.goAnnualObservances()}>
            <div
              className={
                this.state.accordion === dc
                  ? 'sidebar-menuItem active'
                  : 'sidebar-menuItem'
              }
              style={{
                fontWeight: this.state.accordion == dc ? '600' : 'normal',
              }}>
              Calendar of Observances
            </div>
          </div>
        </div>
      )
    } else {
      return (
        <div>
          <div
            className="sidebar-category-section nic_opt_sdm"
            style={{ cursor: 'default' }}>
            <div
              className={'sidebar-menuItem'}
              style={{ fontWeight: 'normal', color: '#5152534a' }}>
              Calendar of Observances ({upgradeTxt})
            </div>
          </div>
        </div>
      )
    }
  }

  renderDEIMaturityModel = (isEnabled) => {
    let { isSetupSkipped } = this.props.user.organizationId

    let { path, accordion, accordinonTabs } = this.state
    let { organizationId } = this.props.user
    let { isDiversityCalendar, selectModule } = organizationId
    // if (
    //   accordion == null &&
    //   accordinonTabs == null
    // ) {
    //   this.setState({ accordion: dmm });
    // }

    if (this.props.user.role !== 'Admin') {
      return
    }

    if (isEnabled) {
      console.log('first')
      return (
        <div>
          <div
            // onClick={() => this.toggleAccordion(d)}
            className="sidebar-category-section"
            onClick={() => this.goDEIMaturityModel()}>
            <div
              className={
                this.state.accordion === dmm
                  ? 'sidebar-menuItem active'
                  : 'sidebar-menuItem'
              }
              style={{
                fontWeight: this.state.accordion == dmm ? '600' : 'normal',
              }}>
              Workplace Assessment
            </div>
          </div>
        </div>
      )
    } else {
      return (
        <div>
          <div
            className="sidebar-category-section nic_opt_sdm"
            style={{ cursor: 'default' }}>
            <div
              className={'sidebar-menuItem'}
              style={{ fontWeight: 'normal', color: '#5152534a' }}>
              Workplace Assessment ({upgradeTxt})
            </div>
          </div>
        </div>
      )
    }
  }

  goToGroups = (val) => {
    let url
    // console.log('val---', val)
    if (val == 1) {
      url =
        this.props.match.url +
        '/groups/' +
        this.props.user.organizationId._id +
        '/discover'
    } else if (val == 0) {
      url =
        this.props.match.url +
        '/groups/' +
        this.props.user.organizationId._id +
        '/feed'
    }
    this.props.history.push(url)
  }

  goToTrivvy = () => {
    // let url;
    // url =
    // this.props.match.url +
    // "/trivia/" +
    // this.props.user.organizationId._id +
    // "/list";
    // this.props.history.push(url);
    this.props.history.push('/list')
  }

  goToProfile = (redirectParam) => {
    let { user } = this.props
    let profileURL = dynamic_urls(user, user.organizationId).my_profile
    // let url = this.props.match.url + '/profile'
    if (redirectParam && redirectParam === 'edit_popup') {
      profileURL = profileURL + `?redirectParam=${redirectParam}`
    }
    this.props.history.push(profileURL)
  }
  goToProfileResults = (redirectParam) => {
    let { user } = this.props
    let profileURL =
      dynamic_urls(user, user.organizationId).my_profile + '/my-trivvys'
    // let url = this.props.match.url + '/profile'
    if (redirectParam && redirectParam === 'edit_popup') {
      profileURL = profileURL + `?redirectParam=${redirectParam}`
    }
    this.props.history.push(profileURL)
  }

  goToMyEvents = () => {
    let { user } = this.props
    let eventURL = dynamic_urls(user, user.organizationId).my_events
    //  let url = this.props.match.url + '/profile/events'
    this.props.history.push(eventURL)
  }

  renderGroups = (isEnabled) => {
    let { path, accordion, accordinonTabs, custom_sidebar } = this.state
    let { organizationId } = this.props.user
    let { isGroups } = organizationId

    if (isEnabled) {
      return (
        <div>
          <div
            // onClick={() => this.toggleAccordion(g)}
            className="sidebar-category-section"
            onClick={() => this.goToGroups(1)}>
            <div
              className={
                this.state.accordion === g
                  ? 'sidebar-menuItem active'
                  : 'sidebar-menuItem'
              }
              style={{
                fontWeight: this.state.accordion == g ? '600' : 'normal',
              }}>
              Groups
            </div>
          </div>

          <Collapse
            isOpen={this.state.accordion == g}
            style={{ paddingBottom: '0px', marginTop: '-10px' }}>
            <Nav vertical className="category-wrapper">
              {this.state.groupCategories.map((category, i) => {
                return (
                  <NavItem key={i} className="nav-item text-md mt10">
                    <span className="sidebar-category">
                      <Link
                        to={
                          this.props.match.url +
                          '/groups/' +
                          this.props.user.organizationId._id +
                          '/' +
                          category.link
                        }
                        className={
                          path.includes('groups') &&
                          path.includes(category.link)
                            ? 'category-active'
                            : 'category'
                        }>
                        {category.name}
                      </Link>
                    </span>
                  </NavItem>
                )
              })}
              <NavItem className="nav-item text-md mt10">
                <span className="sidebar-category">
                  <Link
                    to={this.props.match.url + '/groups/' + 'metrics'}
                    className={
                      path.includes('groups') && path.includes('metrics')
                        ? 'category-active'
                        : 'category'
                    }>
                    Metrics
                  </Link>
                </span>
              </NavItem>
            </Nav>
          </Collapse>
        </div>
      )
    } else {
      return (
        <div>
          <div className="sidebar-category-section nic_opt_sdm">
            <div
              className={'sidebar-menuItem'}
              style={{ fontWeight: 'normal', color: '#5152534a' }}>
              Groups ({upgradeTxt})
            </div>
          </div>
        </div>
      )
    }
  }

  renderPlanning = (isEnabled) => {
    let { path, accordion, accordinonTabs } = this.state
    let { organizationId } = this.props.user
    let { isPlanning, isCultureApp, selectModule } = organizationId
    if (
      isPlanning &&
      isPlanning.status &&
      selectModule &&
      isCultureApp &&
      isCultureApp.status != true &&
      accordion == null &&
      accordinonTabs == null
    ) {
      this.setState({ accordion: p, accordinonTabs: p })
    }

    let planningUrlArr = planningValues.reduce(function(accumulator, curValue) {
      // return accumulator.concat(curValue.selected)
      //curValue.selected = curValue.selected.map(e => "/home/" + e);
      return accumulator.concat(curValue.selected)
    }, [])

    if (isEnabled) {
      return (
        <div>
          <div
            onClick={() => this.toggleAccordion(p)}
            className="sidebar-category-section">
            <div
              className={
                this.state.accordion === p
                  ? 'sidebar-menuItem active'
                  : 'sidebar-menuItem'
              }
              style={{
                fontWeight: this.state.accordion == p ? '600' : 'normal',
              }}>
              Planning
            </div>
            <div
              style={{
                display: 'flex',
                color: '#3B3C41',
                opacity: this.state.accordion == p ? '' : '0.4',
              }}>
              <i className="flaticon-down-arrow sidebar-flaticon-down-arrow" />
            </div>
          </div>

          <Collapse
            isOpen={this.state.accordion == p}
            style={{ paddingBottom: '0px', marginTop: '-10px' }}>
            <Nav vertical className="category-wrapper">
              {this.state.activityCategories.map((category, i) => {
                if (category.key == 0) {
                  return (
                    <NavItem
                      key={i}
                      className={
                        category.link === planningValues.length > 0
                          ? planningValues.filter(
                              (e) => e.typeOf == 'personal'
                            )[0].link
                          : 'my-activity'
                          ? 'nav-item text-md mt10'
                          : 'sideBarNone'
                      }>
                      <span className="sidebar-category">
                        <Link
                          to={this.props.match.url + '/' + category.link}
                          className={
                            path.indexOf('home') > -1 &&
                            category.key == 0 &&
                            category.selected.filter(
                              (e) => path.indexOf(e) > -1
                            ).length > 0
                              ? 'category-active'
                              : 'category'
                          }>
                          {category.name}
                        </Link>
                      </span>
                    </NavItem>
                  )
                } else if (category.key == 1) {
                  return (
                    <NavItem
                      key={i}
                      className={
                        category.link === planningValues.length > 0
                          ? planningValues.filter(
                              (e) => e.typeOf == 'objectives'
                            )[0].link
                          : 'enterprise-objective'
                          ? 'nav-item text-md mt10'
                          : 'sideBarNone'
                      }>
                      <span className="sidebar-category">
                        <Link
                          to={this.props.match.url + '/' + category.link}
                          className={
                            path.indexOf('home') > -1 &&
                            category.key == 1 &&
                            // path.indexOf(category.selected) > -1
                            category.selected.filter(
                              (e) => path.indexOf(e) > -1
                            ).length > 0
                              ? 'category-active'
                              : 'category'
                          }>
                          {category.name}
                        </Link>
                      </span>
                    </NavItem>
                  )
                } else if (category.key == 2) {
                  return (
                    <NavItem
                      key={i}
                      className={
                        category.link === planningValues.length > 0
                          ? planningValues.filter(
                              (e) => e.typeOf == 'public'
                            )[0].link
                          : 'shared-activity'
                          ? 'nav-item text-md mt10'
                          : 'sideBarNone'
                      }>
                      <span className="sidebar-category">
                        <Link
                          to={this.props.match.url + '/' + category.link}
                          className={
                            path.indexOf('home') > -1 &&
                            category.key == 2 &&
                            // path.indexOf(category.selected) > -1
                            category.selected.filter(
                              (e) => path.indexOf(e) > -1
                            ).length > 0
                              ? 'category-active'
                              : 'category'
                          }>
                          {category.name}
                        </Link>
                      </span>
                    </NavItem>
                  )
                } else if (category.key == 3) {
                  return (
                    <NavItem
                      key={i}
                      className={
                        category.link === planningValues.length > 0
                          ? planningValues.filter(
                              (e) => e.typeOf == 'public'
                            )[0].link
                          : 'archived-activity'
                          ? 'nav-item text-md mt10'
                          : 'sideBarNone'
                      }>
                      <span className="sidebar-category">
                        <Link
                          to={this.props.match.url + '/' + category.link}
                          className={
                            path.indexOf('home') > -1 &&
                            category.key == 3 &&
                            category.selected.filter(
                              (e) => path.indexOf(e) > -1
                            ).length > 0
                              ? 'category-active'
                              : 'category'
                          }>
                          {category.name}
                        </Link>
                      </span>
                    </NavItem>
                  )
                }
              })}
            </Nav>
          </Collapse>
        </div>
      )
    } else {
      return (
        <div>
          <div className="sidebar-category-section nic_opt_sdm">
            <div
              className={'sidebar-menuItem'}
              style={{ fontWeight: 'normal', color: '#5152534a' }}>
              Planning ({upgradeTxt})
            </div>
            <div
              style={{
                display: 'flex',
                color: '#3B3C41',
                opacity: '0.4',
              }}>
              <i className="flaticon-down-arrow sidebar-flaticon-down-arrow" />
            </div>
          </div>
        </div>
      )
    }
  }

  renderToolKit = (isEnabled) => {
    let { path, accordion, accordinonTabs } = this.state
    let { organizationId } = this.props.user
    let { isToolkit, isCultureApp, selectModule, isGroups } = organizationId
    if (
      isToolkit &&
      isToolkit.status &&
      selectModule &&
      isCultureApp &&
      isCultureApp.status != true &&
      accordion == null &&
      accordinonTabs == null
    ) {
      this.setState({ accordion: t })
    }
    const groupsPresent = checkValidationOfModule(
      this.props.user.organizationId,
      isGroups
    )
    if (isEnabled || groupsPresent) {
      return (
        <div>
          <div
            className="sidebar-category-section"
            onClick={() => this.toggleAccordion(t)}>
            <div
              className={
                this.state.accordion === t
                  ? 'sidebar-menuItem active'
                  : 'sidebar-menuItem'
              }
              style={{
                fontWeight: this.state.accordion == t ? '600' : 'normal',
              }}>
              Resources
            </div>
            <div
              style={{
                display: 'flex',
                color: 'black',
                opacity: this.state.accordion == t ? '' : '0.4',
              }}>
              <i className="flaticon-down-arrow sidebar-flaticon-down-arrow" />
            </div>
          </div>
          <Collapse
            isOpen={this.state.accordion == t}
            style={{ paddingBottom: '0px', marginTop: '-10px' }}>
            <Nav vertical className="category-wrapper">
              {toolkitCategories
                .filter((x) => !x.isHidden)
                .map((category, i) => {
                  const isCategoryValid = checkValidationOfModule(
                    this.props.user.organizationId,
                    isToolkit
                  )
                    ? true
                    : !checkValidationOfModule(
                        this.props.user.organizationId,
                        isToolkit
                      ) &&
                      checkValidationOfModule(
                        this.props.user.organizationId,
                        isGroups
                      ) &&
                      category.name === 'Conferences & Events'
                    ? true
                    : false
                  return (
                    <NavItem key={i} className="nav-item text-md mt10">
                      <span className="sidebar-category">
                        {isCategoryValid ? (
                          <Link
                            to={
                              this.props.match.url + '/toolkit/' + category.link
                            }
                            className={
                              path.includes('toolkit') &&
                              path.includes(category.link)
                                ? 'category-active'
                                : 'category'
                            }>
                            {category.name}
                          </Link>
                        ) : (
                          <span className="category inactive">
                            {' '}
                            {category.name}
                          </span>
                        )}
                      </span>
                    </NavItem>
                  )
                })}
            </Nav>
          </Collapse>
        </div>
      )
    } else {
      return (
        <div>
          <div className="sidebar-category-section nic_opt_sdm">
            <div
              className={'sidebar-menuItem'}
              style={{ fontWeight: 'normal', color: '#5152534a' }}>
              Resources ({upgradeTxt})
            </div>
            <div
              style={{
                display: 'flex',
                color: 'black',
                opacity: this.state.accordion == t ? '' : '0.4',
              }}>
              <i className="flaticon-down-arrow sidebar-flaticon-down-arrow" />
            </div>
          </div>
        </div>
      )
    }
  }

  renderCultureApp = (isEnabled) => {
    // console.log('props: ', this.props)
    let { path, accordion, accordinonTabs } = this.state
    let { organizationId } = this.props.user
    let { isCultureApp, selectModule } = organizationId
    // accordion==s &&

    if (
      isCultureApp &&
      isCultureApp.status &&
      selectModule &&
      accordion == null &&
      accordinonTabs == null
    ) {
      this.setState({ accordion: s, accordinonTabs: s })
    }

    // let isEnabled =
    //   (isCultureApp && isCultureApp.status && selectModule) ||
    //   !selectModule ||
    //   selectModule == undefined ||
    //   selectModule == null
    //     ? true
    //     : false;

    if (isEnabled) {
      return (
        <div>
          <div
            onClick={() => this.toggleAccordion(s)}
            className="sidebar-category-section">
            <div
              className={
                this.state.accordion === s
                  ? 'sidebar-menuItem active'
                  : 'sidebar-menuItem'
              }
              style={{
                fontWeight: this.state.accordion == s ? '600' : 'normal',
              }}>
              {staticTitles.stories}
            </div>
            <div
              style={{
                display: 'flex',
                color: '#3B3C41',
                opacity: this.state.accordion == s ? '' : '0.4',
              }}>
              <i className="flaticon-down-arrow sidebar-flaticon-down-arrow" />
            </div>
          </div>

          <Collapse
            isOpen={this.state.accordion == s}
            style={{ paddingBottom: '0px', marginTop: '-10px' }}>
            <Nav vertical className="category-wrapper">
              {this.state.storyCategories.map((category, i) => {
                let link =
                  this.props.match.url + '/stories' + category.link !== ''
                    ? '/' + category.link
                    : ''
                let url =
                  this.props.location && this.props.location.pathname
                    ? this.props.location.pathname
                    : window && window.location && window.location.pathname
                    ? window.location.pathname
                    : ''
                if (link.indexOf('me') > -1) {
                  return (
                    <NavItem
                      key={i}
                      className="nav-item text-md mt10"
                      // className={
                      //   category.link === "me"
                      //     ? "nav-item text-md mt10"
                      //     : "sideBarNone"
                      // }
                    >
                      <span className="sidebar-category">
                        <Link
                          to={
                            this.props.match.url + '/stories/' + category.link
                          }
                          className={
                            path.indexOf('home') > -1 &&
                            accordion == s &&
                            path.indexOf(category.link) > -1
                              ? 'category-active'
                              : 'category'
                          }>
                          {category.name}
                        </Link>
                      </span>
                    </NavItem>
                  )
                } else if (link.indexOf('archived') > -1) {
                  let archiveLink =
                    this.props.match.url + '/stories/' + category.link
                  return (
                    <NavItem
                      key={i}
                      className="nav-item text-md mt10"
                      // className={
                      //   category.link === "archived"
                      //     ? "nav-item text-md mt10"
                      //     : "sideBarNone"
                      // }this.props.history.push('/home/upload-data/manual');
                    >
                      <span className="sidebar-category">
                        <Link
                          to={
                            this.props.match.url + '/stories/' + category.link
                          }
                          className={
                            path.indexOf('home') > -1 &&
                            accordion == s &&
                            path.indexOf(category.link) > -1
                              ? 'category-active'
                              : 'category'
                          }>
                          {category.name}
                        </Link>
                      </span>
                    </NavItem>
                  )
                } else if (link.indexOf('trending') > -1) {
                  return (
                    <NavItem
                      key={i}
                      className="nav-item text-md mt10"
                      // className={
                      //   category.link === "archived"
                      //     ? "nav-item text-md mt10"
                      //     : "sideBarNone"
                      // }
                    >
                      <span className="sidebar-category">
                        <Link
                          to={
                            this.props.match.url + '/stories/' + category.link
                          }
                          className={
                            path.indexOf('home') > -1 &&
                            accordion == s &&
                            path.indexOf(category.link) > -1
                              ? 'category-active'
                              : 'category'
                          }>
                          {category.name}
                        </Link>
                      </span>
                    </NavItem>
                  )
                } else if (link.indexOf('inbox') > -1) {
                  return (
                    <NavItem
                      key={i}
                      className="nav-item text-md mt10"
                      // className={
                      //   category.link === "archived"
                      //     ? "nav-item text-md mt10"
                      //     : "sideBarNone"
                      // }
                    >
                      <span className="sidebar-category">
                        <Link
                          to={
                            this.props.match.url + '/stories/' + category.link
                          }
                          className={
                            path.indexOf('home') > -1 &&
                            accordion == s &&
                            path.indexOf(category.link) > -1
                              ? 'category-active'
                              : 'category'
                          }>
                          {category.name}
                        </Link>
                      </span>
                    </NavItem>
                  )
                } else if (link.indexOf('reporting') > -1) {
                  return (
                    <NavItem
                      key={i}
                      className="nav-item text-md mt10"
                      // className={
                      //   category.link === "archived"
                      //     ? "nav-item text-md mt10"
                      //     : "sideBarNone"
                      // }
                    >
                      <span className="sidebar-category">
                        <Link
                          to={
                            this.props.match.url + '/stories/' + category.link
                          }
                          className={
                            path.indexOf('home') > -1 &&
                            accordion == s &&
                            path.indexOf(category.link) > -1
                              ? 'category-active'
                              : 'category'
                          }>
                          {category.name}
                        </Link>
                      </span>
                    </NavItem>
                  )
                } else {
                  return (
                    <NavItem
                      key={i}
                      className="nav-item text-md mt10"
                      // className={
                      //   category.link === ""
                      //     ? "nav-item text-md mt10"
                      //     : "sideBarNone"
                      // }
                    >
                      <span className="sidebar-category">
                        <Link
                          to={this.props.match.url + '/stories'}
                          className={
                            // path.indexOf("home") > -1 &&
                            // path.indexOf(category.link) > -1 &&
                            path.indexOf('home') > -1 &&
                            accordion == s &&
                            url === '/home/stories' &&
                            path.indexOf('me') === -1 &&
                            path.indexOf('archived') === -1 &&
                            path.indexOf('trending') === -1
                              ? 'category-active'
                              : 'category'
                          }>
                          {category.name}
                        </Link>
                      </span>
                    </NavItem>
                  )
                }
              })}
            </Nav>
          </Collapse>
        </div>
      )
    } else {
      return (
        <div>
          <div className="sidebar-category-section nic_opt_sdm">
            <div
              className={'sidebar-menuItem'}
              style={{ fontWeight: 'normal', color: '#5152534a' }}>
              {staticTitles.stories} ({upgradeTxt})
            </div>
            <div
              style={{
                display: 'flex',
                color: '#3B3C41',
                opacity: '0.4',
              }}>
              <i className="flaticon-down-arrow sidebar-flaticon-down-arrow" />
            </div>
          </div>
        </div>
      )
    }
  }

  renderAnalytics = (isEnabled) => {
    let { isSetupSkipped } = this.props.user.organizationId
    let { path, accordion, accordinonTabs } = this.state
    let { organizationId } = this.props.user
    let { isAnalytics, isCultureApp, selectModule } = organizationId
    if (
      isAnalytics &&
      isAnalytics.status &&
      selectModule &&
      isCultureApp &&
      isCultureApp.status != true &&
      accordion == null &&
      accordinonTabs == null
    ) {
      this.setState({ accordion: a, accordinonTabs: a })
    }

    if (
      // !isSetupSkipped &&
      // ((isAnalytics && isAnalytics.status && selectModule) ||
      //   !selectModule ||
      //   selectModule == undefined ||
      //   selectModule == null)
      !isSetupSkipped &&
      isEnabled
    ) {
      return (
        <div>
          <div>
            <div
              onClick={() => this.toggleAccordion(a)}
              className="sidebar-category-section">
              <div
                className={
                  this.state.accordion === a
                    ? 'sidebar-menuItem active'
                    : 'sidebar-menuItem'
                }
                style={{
                  fontWeight: this.state.accordion == a ? '600' : 'normal',
                }}>
                Analytics
              </div>

              <div
                style={{
                  display: 'flex',
                  color: '#3B3C41',
                  opacity: this.state.accordion == a ? '' : '0.4',
                }}>
                <i className="flaticon-down-arrow sidebar-flaticon-down-arrow" />
              </div>
            </div>
            <Collapse
              isOpen={this.state.accordion == a || this.isAnalyticsUrl()}
              style={{ paddingBottom: '0px', marginTop: '-10px' }}>
              <Nav vertical className="category-wrapper">
                {this.props.analyticsCategories.map((category, i) => {
                  return (
                    <NavItem key={i} className="nav-item text-md mt10">
                      <span className="sidebar-category">
                        <Link
                          to={
                            this.props.match.url + '/analytics/' + category.link
                          }
                          className={
                            path.includes('analytics') &&
                            path.includes(category.link)
                              ? 'category-active'
                              : 'category'
                          }>
                          {category.name}
                        </Link>
                      </span>
                    </NavItem>
                  )
                })}
              </Nav>
            </Collapse>
          </div>
        </div>
      )
    } else {
      return (
        <div>
          <div>
            <div className="sidebar-category-section nic_opt_sdm">
              <div
                className={'sidebar-menuItem'}
                style={{ fontWeight: 'normal', color: '#5152534a' }}>
                Analytics ({upgradeTxt})
              </div>

              <div
                style={{
                  display: 'flex',
                  color: '#3B3C41',
                  opacity: '0.4',
                }}>
                <i className="flaticon-down-arrow sidebar-flaticon-down-arrow" />
              </div>
            </div>
          </div>
        </div>
      )
    }
  }

  customSidebarCheck = (custom_sidebar, tab) => {
    console.log('tab --- ', tab)
    if (false) {
      if (tab == trv) {
        return true
      } else {
        return false
      }
    } else {
      if (tab == trv) {
        return true
      } else if (tab != trv && !isTrivvyUrl(this.props.user.organizationId)) {
        if (!custom_sidebar || custom_sidebar == null) {
          return true
        } else if (custom_sidebar == tab) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    }
  }

  getInitials = (user) => {
    let firstName =
      user.firstName && user.firstName.length > 0 ? user.firstName : 'N'
    let lastName =
      user.lastName && user.lastName.length > 0 ? user.lastName : 'N'
    return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase()
  }

  check_if_my_profile = (val) => {
    let { location, user } = this.props
    if (location.pathname.indexOf(user._id) > -1) {
      if (val == 'P') {
        if (this.state.accordion === m) {
          return true
        }
        return false
      }

      if (val == 'E') {
        if (this.state.accordion === events) {
          return true
        }
        return false
      }

      return false
    }
    return false
  }

  renderReporting = () => {
    let { path, accordion, accordinonTabs } = this.state
    let { orgAdmin } = this.props.user

    const organizationDoc = this.props.user.organizationId

    const reportingCount = organizationDoc.reportingTotal
      ? organizationDoc.reportingTotal.story +
        organizationDoc.reportingTotal.comments
      : 0

    if (orgAdmin) {
      return (
        <div>
          <div>
            <div
              onClick={() => this.toggleAccordion(r)}
              className="sidebar-category-section">
              <div
                className={
                  this.state.accordion === r
                    ? 'sidebar-menuItem active'
                    : 'sidebar-menuItem'
                }
                style={{
                  fontWeight: this.state.accordion == r ? '600' : 'normal',
                }}>
                Reporting{' '}
                {reportingCount > 0 ? <span>({reportingCount})</span> : ''}
              </div>

              <div
                style={{
                  display: 'flex',
                  color: '#3B3C41',
                  opacity: this.state.accordion == r ? '' : '0.4',
                }}>
                <i className="flaticon-down-arrow sidebar-flaticon-down-arrow" />
              </div>
            </div>
            <Collapse
              isOpen={this.state.accordion == r || this.isReportingUrl()}
              style={{ paddingBottom: '0px', marginTop: '-10px' }}>
              <Nav vertical className="category-wrapper">
                {this.props.reportingCategories.map((category, i) => {
                  return (
                    <NavItem key={i} className="nav-item text-md mt10">
                      <span className="sidebar-category">
                        <Link
                          to={
                            this.props.match.url + '/reporting/' + category.link
                          }
                          className={
                            path.includes('reporting') &&
                            path.includes(category.link)
                              ? 'category-active'
                              : 'category'
                          }>
                          {category.name}
                        </Link>
                      </span>
                    </NavItem>
                  )
                })}
              </Nav>
            </Collapse>
          </div>
        </div>
      )
    } else {
      return ''
    }
  }

  addTrivvySuccessFromTemplates = (data) => {
    if (this.props.setImportTemplateAddedTrivvys) {
      this.props.setImportTemplateAddedTrivvys(data)
      this.setState({
        trivvyTemplateModalOpen: false,
      })
    }
  }

  renderTrivvySettings = () => {
    const {
      uploadUsersModal,
      purchaseResponsesModal,
      inviteAdminModal,
      upgradePlanModal,
      trivvyTemplateModalOpen,
      missionValuesIndustryModal,
    } = this.state
    const orgObject = this.props.user.organizationId

    const totalAllowed = orgObject.totalTriviaResponsesCount
    const totalSubmitted = orgObject.submittedTriviaResponsesCount

    const trivvyPlanType = orgObject.trivvyPlanType

    const percent = (totalSubmitted / totalAllowed) * 100

    let smsPercent = null

    if (orgObject.smsLimit) {
      smsPercent = Math.round(
        (orgObject.totalSmsSent / orgObject.smsLimit) * 100
      )
    }
    const canPurchaseResponses =
      this.props.user.orgAdmin || this.props.user.role == 'Admin'

    if (canPurchaseResponses) {
      return (
        <div className="mt-1" id="trivia_ui_responses_counter">
          <div className="gray-text-sm sidebar_font_md">
            {' '}
            <RiSurveyFill className="mr-1" />
            Responses Collected
          </div>
          <div>
            <Progress value={percent} />
            {totalSubmitted} /{' '}
            <span className="gray-text-sm"> {totalAllowed} </span>
            {/* <span
              className="cursor-pointer font-11px trivvy-sidebar-mng-resp float-right"
              onClick={() => this.setState({ purchaseResponsesModal: true })}
            >
              (Increase response limit)
            </span> */}
          </div>

          {smsPercent != null && (
            <div className="my-3">
              <div className="gray-text-sm sidebar_font_md">
                {' '}
                <RiMessage2Fill className="mr-1" />
                SMS Texts{' '}
                {minPlanLimitCheck(orgObject.trivvyPlanType, '003')
                  ? 'included'
                  : ''}
              </div>
              {minPlanLimitCheck(orgObject.trivvyPlanType, '003') ? (
                ''
              ) : (
                <span>
                  <Progress value={smsPercent} />
                  {orgObject.totalSmsSent} /{' '}
                  <span className="gray-text-sm"> {orgObject.smsLimit} </span>
                  {/* {this.props.user.orgAdmin && orgObject.trivvyPlanType ? (
                  // orgObject.trivvyPlanType != "001"

                    <span
                      className="trivvy-sidebar-add-user-seat font-11px"
                      onClick={() => {
                        this.setState({ inviteAdminModal: true });
                      }}
                    >
                      (Manage Plan)
                    </span>

                ) : (
                  ""
                )} */}
                </span>
              )}
            </div>
          )}

          <div className="mt-3 trivvy-color sidebar_font_md">
            <IoHourglassOutline className="" />{' '}
            {orgObject.waitingTriviaResponsesCount} waiting
          </div>
          {purchaseResponsesModal && (
            <ResponsePurchaseModal
              open={purchaseResponsesModal}
              orgChangeSuccess={this.props.orgChangeSuccess}
              onClose={() => {
                this.setState({
                  purchaseResponsesModal: false,
                })
              }}
              showResponseTable={['002', '003', '004'].includes(
                orgObject.trivvyPlanType
              )}
            />
          )}

          {['001', '002', '003', '004'].includes(orgObject.trivvyPlanType) ? (
            <div
              className="mt-3 cursor-pointer trivvy-sidebar-mng-resp sidebar_font_md"
              onClick={
                ['002', '003', '004'].includes(orgObject.trivvyPlanType)
                  ? () => this.setState({ purchaseResponsesModal: true })
                  : null
              }
              style={{
                display: 'flex',
                gap: '3px',
                opacity: ['002', '003', '004'].includes(
                  orgObject.trivvyPlanType
                )
                  ? 1
                  : 0.6,
              }}>
              <BsGearFill className="mt-1" />{' '}
              {`Increase Response/SMS Text Limit
              ${
                ['002', '003', '004'].includes(orgObject.trivvyPlanType)
                  ? ''
                  : '(only available on paid plans)'
              }
              `}
            </div>
          ) : (
            ''
          )}

          {this.props.user.orgAdmin && orgObject.trivvyPlanType ? (
            // orgObject.trivvyPlanType != "001"
            <div
              className="mt-3"
              style={{ display: 'flex', gap: '3px', cursor: 'pointer' }}
              onClick={() => {
                this.setState({ inviteAdminModal: true })
              }}>
              <MdEventSeat className={''} size={19} />
              <a className="trivvy-sidebar-add-user-seat sidebar_font_md">
                Manage Plan: (Current: {getTrivvyPlanName(trivvyPlanType)})
              </a>
            </div>
          ) : (
            ''
          )}

          {this.props.user.orgAdmin ? (
            // orgObject.trivvyPlanType != "001"
            <div
              className="mt-3"
              style={{ display: 'flex', gap: '3px', cursor: 'pointer' }}
              onClick={() => {
                this.setState({ missionValuesIndustryModal: true })
              }}>
              <FaBuilding className="mb-1" />
              <a className="trivvy-sidebar-add-user-seat sidebar_font_md">
                Mission, Values and Industry
              </a>
            </div>
          ) : (
            ''
          )}

          {missionValuesIndustryModal && (
            <TrivvyEnterpriseConfigsModal
              open={missionValuesIndustryModal}
              onClose={() =>
                this.setState({ missionValuesIndustryModal: false })
              }
            />
          )}

          {upgradePlanModal && (
            <UpgradePlanModal
              open={upgradePlanModal}
              onClose={() => this.setState({ upgradePlanModal: false })}
            />
          )}

          {inviteAdminModal && (
            <InviteAdminsTrivvy
              open={inviteAdminModal}
              onClose={() => this.setState({ inviteAdminModal: false })}
              history={this.props.history}
            />
          )}

          {trivvyTemplateModalOpen && (
            <TriviaTemplatesModalMain
              open={trivvyTemplateModalOpen}
              onClose={() => this.setState({ trivvyTemplateModalOpen: false })}
              addTrivvySuccessFromTemplates={this.addTrivvySuccessFromTemplates}
            />
          )}

          {/* <Button
            className="trivia-action-button-main mr-4 trivv-create-btn mt-4"
            onClick={() => {
              this.setState({
                trivvyTemplateModalOpen: true,
              });
            }}
            style={{whiteSpace:"nowrap"}}
            // color="success"
            size="sm"
          >
            <BiNotepad /> {isMobile ? "Trivvy": window.innerWidth < 1200 ? "":"Trivvy" }  Templates
          </Button> */}
        </div>
      )
    } else {
      return null
    }
  }

  renderMainSideBar = () => {
    let { custom_sidebar, accordion, genderPronounInstOpen } = this.state
    let { user } = this.props
    let {
      isSetupSkipped,
      isToolkit,
      isPlanning,
      isCultureApp,
      isAnalytics,
      isGroups,
      isDiversityCalendar,
      isDEIMaturityModel,
      selectModule,
      isSignedUpFromTrivvyWebsite,
      trivvyPlanType,
      _id,
    } = this.props.user.organizationId
    // console.log('accordion : ', accordion)

    const trivvyProductSidebar =
      isSignedUpFromTrivvyWebsite ||
      window.location.pathname.indexOf('/home/trivia') >= 0
    if (
      // !trivvyProductSidebar
      true
    ) {
      return (
        <div
          className={`offset-md-0 col-md-2 col-lg-2 side-navbar-bg cursor-pointer position-fixed`}
          style={{
            overflow: 'auto',
            paddingBottom: '35px',
          }}
          // className={`offset-md-0 col-md-2 col-lg-2 side-navbar-bg cursor-pointer leftSidebar`}
        >
          <span
            className={trivvyProductSidebar ? 'poweredByTrivvy' : 'poweredByOO'}
            style={{ zIndex: 0 }}>
            {!trivvyProductSidebar ? (
              'Powered by OurOffice'
            ) : (
              <div>
                <div>
                  <img src={trivvyLogo} width="14px" />
                  <span
                    className="sidebar-trivvy-logo-txt"
                    data-tip={TRIVIA_DESCRIPTION}
                    style={{
                      fontSize: '13px',
                    }}>
                    Trivvy
                  </span>

                  <ReactTooltip />
                </div>
              </div>
            )}
          </span>

          <div
          // className="sideBarMenuItems"
          // style={{
          //   boxShadow:
          //     _id == "64ba1da551579e7b3d7a2a56"
          //       ? "unset"
          //       : "0 1px 5px rgb(0 0 0 / 17%)",
          // }}
          >
            {/* this.state.accordion===m  */}
            <div className="sidebar-category-section sidebar_conatiner_my_profile_menu_section mb-2">
              <div className={'sidebar-menuItem'}>
                <span className="sidebar_container_my_profile_menu_block">
                  {profilePicValidityCheck(user.profilePic) ? (
                    <img
                      className="sidebar_container_my_profile_menu_img"
                      onClick={() => this.goToProfile()}
                      src={user.profilePic}
                    />
                  ) : (
                    <span
                      onClick={() => this.goToProfile()}
                      data-letters={this.getInitials(this.props.user)}></span>
                  )}
                  <span
                    className={`sidebar_container_my_profile_menu_name sidebar-menuItem ${
                      this.check_if_my_profile('P') ? 'active' : ''
                    }`}
                    style={{
                      fontWeight: this.state.accordion == m ? '600' : 'normal',
                    }}>
                    <span
                      className="sidebar_font_md"
                      onClick={() => this.goToProfile()}>
                      My Profile
                    </span>

                    {this.props.user.genderPronoun != null &&
                    typeof this.props.user.genderPronoun != 'undefined' &&
                    this.props.user.genderPronoun >= 0 ? (
                      <span className="user_gender_pronoun_sidebar">
                        {renderGenderPronoun(this.props.user)}
                      </span>
                    ) : (
                      <div className="gender_pronoun_add_sidebar_section">
                        <span
                          onClick={() =>
                            this.check_if_my_profile('P')
                              ? null
                              : this.goToProfile('edit_popup')
                          }>
                          (Add Gender Pronoun?){' '}
                        </span>

                        <span
                          id="gender_pronoun_instructions"
                          className="cursor-pointer"
                          onClick={() => {
                            this.setState({
                              genderPronounInstOpen: !genderPronounInstOpen,
                            })
                          }}
                          style={{ marginLeft: '-10px' }}>
                          <img
                            src={tooltipIcon}
                            alt="tooltip"
                            style={{
                              height: '9px',
                              width: '9px',
                              cursor: 'pointer',
                              marginLeft: '10px',
                            }}
                          />
                        </span>
                      </div>
                    )}

                    <Modal
                      isOpen={genderPronounInstOpen}
                      toggle={() => {
                        this.setState({
                          genderPronounInstOpen: !genderPronounInstOpen,
                        })
                      }}>
                      <ModalHeader
                        className="popover-header-tooltip"
                        toggle={() => {
                          this.setState({
                            genderPronounInstOpen: !genderPronounInstOpen,
                          })
                        }}>
                        Gender Pronouns
                      </ModalHeader>
                      <ModalBody className="sidebar_gp_modal ">
                        <p>
                          {' '}
                          Gender pronouns signify how someone would like to be
                          referred to with regards to their gender identity.
                          Gender goes well beyond a few letters on a driver’s
                          license or birth certificate, though — it is a core
                          piece of a person’s identity. There are a number of
                          personal pronouns used for different groups and
                          identities:
                        </p>
                        <ul>
                          <li>
                            <strong>He/him/his</strong>: Male pronouns
                          </li>
                          <li>
                            <strong>She/her/hers</strong>: Female pronouns
                          </li>
                          <li>
                            <strong>They/them/theirs</strong>: Gender-neutral
                            group pronouns and singular pronouns as well
                          </li>
                          <li>
                            <strong>Ze/zir/zirs</strong>: Neutral singular
                            pronouns for those not wanting to use
                            they/them/theirs
                          </li>
                        </ul>
                        <p>
                          {' '}
                          <strong>Gender pronouns </strong> are an important
                          part of one’s identity and carry personal and cultural
                          context. Using the wrong pronoun can be offensive and
                          put someone in a difficult or awkward situation, as
                          you’re disrespecting their identity and denying them a
                          big part of who they are. It’s a common misconception
                          that you can tell someone’s gender by looking at them.
                          There are no physical constraints to gender, so
                          judging someone by appearance is not always the right
                          approach{' '}
                        </p>
                      </ModalBody>
                    </Modal>
                  </span>
                </span>
              </div>
            </div>

            {!isTrivvyUrl(this.props.user.organizationId) ? (
              <div
                onClick={() => this.goToMyEvents()}
                className="sidebar-category-section">
                <div className={'sidebar-menuItem'}>
                  <span className="sidebar_container_my_profile_menu_block">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="sidebar-calander-events"
                      // fill="white"
                      fill="#be0000cc"
                      viewBox="0 0 200 200.016">
                      <path d="M132.829 7.699c0-4.248 4.199-7.699 9.391-7.699s9.391 3.451 9.391 7.699v33.724c0 4.248-4.199 7.699-9.391 7.699s-9.391-3.451-9.391-7.699zm-5.941 123.747c2.979 0 5.404 2.425 5.404 5.404s-2.425 5.404-5.404 5.404l-21.077-.065-.065 21.045c0 2.979-2.425 5.404-5.404 5.404s-5.404-2.425-5.404-5.404l.065-21.061-21.045-.081c-2.979 0-5.404-2.425-5.404-5.404s2.425-5.404 5.404-5.404l21.061.065.065-21.045c0-2.979 2.425-5.404 5.404-5.404s5.404 2.425 5.404 5.404l-.065 21.077 21.061.065zM48.193 7.699C48.193 3.451 52.393 0 57.585 0s9.391 3.451 9.391 7.699v33.724c0 4.248-4.199 7.699-9.391 7.699s-9.391-3.451-9.391-7.699zM10.417 73.763h179.167V34.945c0-1.302-.537-2.49-1.4-3.369-.863-.863-2.051-1.4-3.369-1.4h-17.171c-2.881 0-5.208-2.327-5.208-5.208s2.327-5.208 5.208-5.208h17.171c4.183 0 7.975 1.709 10.726 4.46S200 30.762 200 34.945v44.043 105.843c0 4.183-1.709 7.975-4.46 10.726s-6.543 4.46-10.726 4.46H15.186c-4.183 0-7.975-1.709-10.726-4.46C1.709 192.79 0 188.997 0 184.814V78.988 34.945c0-4.183 1.709-7.975 4.46-10.726s6.543-4.46 10.726-4.46h18.343c2.881 0 5.208 2.327 5.208 5.208s-2.327 5.208-5.208 5.208H15.186c-1.302 0-2.49.537-3.369 1.4-.863.863-1.4 2.051-1.4 3.369zm179.167 10.433H10.417v100.618c0 1.302.537 2.49 1.4 3.369.863.863 2.051 1.4 3.369 1.4h169.629c1.302 0 2.49-.537 3.369-1.4.863-.863 1.4-2.051 1.4-3.369zM82.08 30.176c-2.881 0-5.208-2.327-5.208-5.208s2.327-5.208 5.208-5.208h34.977c2.881 0 5.208 2.327 5.208 5.208s-2.327 5.208-5.208 5.208z"></path>
                    </svg>
                    <span
                      className={`sidebar_container_my_profile_menu_name sidebar-menuItem ${
                        this.check_if_my_profile('E') ? 'active' : ''
                      }`}
                      style={{
                        fontWeight:
                          this.state.accordion == m ? '600' : 'normal',
                      }}>
                      My Events
                    </span>
                  </span>
                </div>
              </div>
            ) : null}

            {isTrivvyUrl(this.props.user.organizationId) ? (
              <div
                onClick={() => this.goToProfileResults()}
                className="sidebar-category-section mb-0">
                <div className={'sidebar-menuItem'}>
                  <span className="sidebar_container_my_profile_menu_block">
                    <FaTasks size={15} className="mr-2" />
                    <span
                      className={`sidebar-menuItem sidebar_font_md ${
                        window.location.pathname.indexOf('/my-trivvys') >= 0
                          ? 'active'
                          : ''
                      }`}
                      style={{
                        fontWeight:
                          this.state.accordion == m ? '600' : 'normal',
                      }}>
                      My Trivvys
                    </span>
                  </span>
                </div>
              </div>
            ) : null}

            {/* Dashboard, Planning, Groups, Analytics, Culture App, Resources. */}

            {this.customSidebarCheck(custom_sidebar, trv)
              ? this.renderTrivia()
              : null}
          </div>

          {/* <div
            onClick={() => this.goToMyEvents()}
            className="sidebar-category-section"
          >
            <div className={"sidebar-menuItem"}>
              <span className="sidebar_container_my_profile_menu_block">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="sidebar-calander-events"
                  // fill="white"
                  fill="#be0000cc"
                  viewBox="0 0 200 200.016"
                >
                  <path d="M132.829 7.699c0-4.248 4.199-7.699 9.391-7.699s9.391 3.451 9.391 7.699v33.724c0 4.248-4.199 7.699-9.391 7.699s-9.391-3.451-9.391-7.699zm-5.941 123.747c2.979 0 5.404 2.425 5.404 5.404s-2.425 5.404-5.404 5.404l-21.077-.065-.065 21.045c0 2.979-2.425 5.404-5.404 5.404s-5.404-2.425-5.404-5.404l.065-21.061-21.045-.081c-2.979 0-5.404-2.425-5.404-5.404s2.425-5.404 5.404-5.404l21.061.065.065-21.045c0-2.979 2.425-5.404 5.404-5.404s5.404 2.425 5.404 5.404l-.065 21.077 21.061.065zM48.193 7.699C48.193 3.451 52.393 0 57.585 0s9.391 3.451 9.391 7.699v33.724c0 4.248-4.199 7.699-9.391 7.699s-9.391-3.451-9.391-7.699zM10.417 73.763h179.167V34.945c0-1.302-.537-2.49-1.4-3.369-.863-.863-2.051-1.4-3.369-1.4h-17.171c-2.881 0-5.208-2.327-5.208-5.208s2.327-5.208 5.208-5.208h17.171c4.183 0 7.975 1.709 10.726 4.46S200 30.762 200 34.945v44.043 105.843c0 4.183-1.709 7.975-4.46 10.726s-6.543 4.46-10.726 4.46H15.186c-4.183 0-7.975-1.709-10.726-4.46C1.709 192.79 0 188.997 0 184.814V78.988 34.945c0-4.183 1.709-7.975 4.46-10.726s6.543-4.46 10.726-4.46h18.343c2.881 0 5.208 2.327 5.208 5.208s-2.327 5.208-5.208 5.208H15.186c-1.302 0-2.49.537-3.369 1.4-.863.863-1.4 2.051-1.4 3.369zm179.167 10.433H10.417v100.618c0 1.302.537 2.49 1.4 3.369.863.863 2.051 1.4 3.369 1.4h169.629c1.302 0 2.49-.537 3.369-1.4.863-.863 1.4-2.051 1.4-3.369zM82.08 30.176c-2.881 0-5.208-2.327-5.208-5.208s2.327-5.208 5.208-5.208h34.977c2.881 0 5.208 2.327 5.208 5.208s-2.327 5.208-5.208 5.208z"></path>
                </svg>
                <span
                  className={`sidebar_container_my_profile_menu_name sidebar-menuItem ${
                    this.check_if_my_profile("E") ? "active" : ""
                  }`}
                  style={{
                    fontWeight: this.state.accordion == m ? "600" : "normal",
                  }}
                >
                  My Events
                </span>
              </span>
            </div>
          </div> */}

          {/* Dashboard, Planning, Groups, Analytics, Culture App, Resources. */}

          {this.customSidebarCheck(custom_sidebar, d)
            ? this.renderDashboard()
            : null}

          {this.customSidebarCheck(custom_sidebar, p)
            ? this.validateEnableModule(isSetupSkipped, isPlanning, 'Planning')
            : null}

          {this.customSidebarCheck(custom_sidebar, g)
            ? this.validateEnableModule(isSetupSkipped, isGroups, 'Groups')
            : null}

          {this.customSidebarCheck(custom_sidebar, a)
            ? this.validateEnableModule(
                isSetupSkipped,
                isAnalytics,
                'Analytics'
              )
            : null}

          {this.customSidebarCheck(custom_sidebar, s)
            ? this.validateEnableModule(
                isSetupSkipped,
                isCultureApp,
                'CultureApp'
              )
            : null}
          {this.customSidebarCheck(custom_sidebar, dmm)
            ? this.validateEnableModule(
                isSetupSkipped,
                isDEIMaturityModel,
                'DEIMaturityModel'
              )
            : null}
          {this.customSidebarCheck(custom_sidebar, dc)
            ? this.validateEnableModule(
                isSetupSkipped,
                isDiversityCalendar,
                'DiversityCalendar'
              )
            : null}

          {this.customSidebarCheck(custom_sidebar, t)
            ? this.validateEnableModule(isSetupSkipped, isToolkit, 'Toolkit')
            : null}
          {/* {this.customSidebarCheck(custom_sidebar, r)
            ? this.renderReporting()
            : null} */}
        </div>
      )
    } else {
      const { uploadUsersModal, purchaseResponsesModal } = this.state

      const { orgAdmin, role } = this.props.user

      const canPurchaseResponses = orgAdmin || role == 'Admin'

      return (
        <div
          // className="offset-md-1 offset-sm-1 col-md-2 col-sm-2 sidebar side-navbar-bg position-fixed"
          className="offset-md-0 col-md-2 col-lg-2 side-navbar-bg position-fixed cursor-pointer trivvy-logo-container trivvy_single_menu_padding">
          <div
            onClick={() => this.goToTrivvy()}
            className="pt-3 trivvy-logo-container-itm">
            <img src={trivvyLogo} className="sidebar-trivvy-logo-img" />
            <span
              className="sidebar-trivvy-logo-txt"
              data-tip={TRIVIA_DESCRIPTION}>
              Trivvy
            </span>

            <ReactTooltip />
          </div>

          {canPurchaseResponses && this.renderTrivvySettings()}

          {/* <img src={trivvyTxt} /> */}
          {/* {uploadUsersModal && (
            <UploadUsersModal
              open={uploadUsersModal}
              onClose={() => {
                this.setState({
                  uploadUsersModal: false,
                });
              }}
            />
          )} */}
        </div>
      )
    }
  }

  render() {
    return this.renderMainSideBar()
  }
}

export default withRouter(SideBar)
